export default __webpack_public_path__ + "static/media/4.a79b7701.jpg";